export const LOADING_PAGE_TEST_ID = 'loading-page'
